(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('media-gallery[data-presentation="grid"]').forEach(gallery => {
      const thumbs = gallery.querySelectorAll('.media-gallery__grid-thumb');
      const gridItems = gallery.querySelectorAll('.media-gallery__grid li.product-media-container');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.getAttribute('data-grid-thumb-index'), 10);

          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');

          const target = gridItems[index];
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
